import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useAuthorizedAxios } from '../../../../core/hooks';
import { isValidCustomerId } from '../../../../customers';
import { ChartSettings } from '../../../chart-settings/model';
import { getCpuMeasurements } from '../../api';
import { CpeMonitoredDevicesQuery } from '../../config';
import { mapDeviceCpuMeasurementModelToTimeSeriesMeasurement } from '../../model';
import { TimeSeriesMeasurement } from '../../../timeseries-statistics/model/TimeSeriesMeasurement.model';

export const useCpuMeasurementsApiGet = (
  customerId: number | null,
  deviceId: string,
  chartSettings: ChartSettings,
  queryKeyIdPart: string
): UseQueryResult<TimeSeriesMeasurement[] | null, Error> => {
  const axios = useAuthorizedAxios();
  return useQuery<TimeSeriesMeasurement[] | null, Error>({
    queryKey: [CpeMonitoredDevicesQuery['GetCpuMeasurements'].key, customerId, deviceId, chartSettings, queryKeyIdPart],
    queryFn: async () => {
      if (customerId === null) {
        return null;
      } else {
        const measurements = await getCpuMeasurements(axios, { customerId, deviceId, chartSettings });
        return measurements.map(mapDeviceCpuMeasurementModelToTimeSeriesMeasurement);
      }
    },
    enabled: isValidCustomerId(customerId) && Boolean(deviceId),
    gcTime: 30000,
    staleTime: 1000,
    structuralSharing: false
  });
};